// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_2z3PUCsAYm"};
    if(module.hot) {
      // 1614934747490
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  